import api from '../api'

export interface TeamMember {
  id: number
  user_id: number
  team_id: number
  role: string
  status: string
  created_at: string
  updated_at: string
  user: {
    id: number
    email: string
    role: string
    first_name?: string
    last_name?: string
    full_name?: string
    skills?: Array<{
      id: number
      name: string
      category: string
    }>
    user_skills?: Array<{
      id: number
      proficiency_level: number
      rate: number
      skill: {
        id: number
        name: string
        category: string
        description?: string
      }
    }>
  }
  team: {
    id: number
    name: string
  }
}

interface TeamMemberFormData {
  user_id: number
  team_id: number
  role: string
  status: string
}

export interface User {
  id: number
  email: string
  role: string
  user_skills: any[]
}

export interface Team {
  id: number
  name: string
}

export const teamMembersApi = {
  // Get all team members
  getAll: async (params?: { status?: string; skill_id?: number }) => {
    const response = await api.get<{ team_members: TeamMember[] }>('/team_members', { params })
    return response.data
  },

  // Get team members by skill
  getBySkill: async (skillId: number) => {
    const response = await api.get<{ team_members: TeamMember[]; skill: any }>(`/team_members/by_skill/${skillId}`)
    return response.data
  },

  // Create team member
  create: async (data: TeamMemberFormData) => {
    const response = await api.post<{ team_member: TeamMember; message: string }>('/team_members', { team_member: data })
    return response.data
  },

  // Update team member
  update: async (id: number, data: Partial<TeamMemberFormData>) => {
    const response = await api.put<{ team_member: TeamMember; message: string }>(`/team_members/${id}`, { team_member: data })
    return response.data
  },

  // Delete team member
  delete: async (id: number) => {
    await api.delete(`/team_members/${id}`)
  },

  // Get all users (for selection)
  getUsers: async () => {
    const response = await api.get<{ users: User[] }>('/users')
    return response.data
  },

  // Get all teams (for selection)
  getTeams: async () => {
    const response = await api.get<{ teams: Team[] }>('/teams')
    return response.data
  },
}
